var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.63 68.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #29aed5;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fefefe;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #2aafd5;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #35b3d7;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fdfefe;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.63,34.08c-.25,6.54.43,12.71-.88,18.82-1.66,7.75-7,13.19-14.77,14.22a137.41,137.41,0,0,1-36.8,0C7.28,65.91,1.55,59.65.76,50.75a183.45,183.45,0,0,1,0-33.39C1.7,7.1,8.93.3,19.27.13Q34.5-.12,49.72.15c9.74.18,16.44,6.28,18.21,15.9C69.05,22.18,68.29,28.34,68.63,34.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.76,33.82c0-5-.26-10,.06-15,.52-8,4.77-12.35,12.66-12.6,10-.31,20-.33,30,0,7.69.27,11.77,4.66,12.45,12.27a170.44,170.44,0,0,1,0,30.89c-.66,7.18-4.12,10.92-11.14,11.81a132,132,0,0,1-32.33,0c-7.32-.88-11.06-4.58-11.54-12C6.51,44.16,6.78,39,6.78,33.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.09,51.22A17,17,0,0,1,16.82,33.86a17.54,17.54,0,1,1,35.07,0C51.87,44,44.4,51.26,34.09,51.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.19,11.85c2.91.07,4.5,1.3,4.42,3.92a3.81,3.81,0,0,1-4.17,4,3.76,3.76,0,0,1-3.81-3.82C48.52,13.23,50,12.05,52.19,11.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.72,33.74A11.22,11.22,0,0,1,34.4,45.18,11.38,11.38,0,0,1,22.91,33.81,11.79,11.79,0,0,1,34.08,22.48,11.5,11.5,0,0,1,45.72,33.74Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.783b12aac57a57f5b95cabd273fede9d.svg";
export { ForwardRef as ReactComponent };